import type {FunctionComponent} from "react";
import {WarningOutlined} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";
import {ToastContent} from "../../../../@bizkeytech";


const TestToastContent: FunctionComponent<ToastContentProps> = (props) => {

    return (
        <>
            <ToastContent
                title={'Test Toast'}
                message={'This is a test toast.'}
                icon={<WarningOutlined color={'warning'}/>}
                className={typeof props.toastProps.className === 'string' ? props.toastProps.className : ''}
                toastProps={props.toastProps}
            />
        </>
    )
}

export default TestToastContent;
